export const translations = {
  ar: {
    dir: "rtl",
    // Nav
    brand: "عقاراتي",
    login: "تسجيل الدخول",
    register: "إنشاء حساب",
    logout: "تسجيل الخروج",
    dashboard: "لوحة التحكم",
    calendar: "التقويم",
    finances: "المالية",
    reports: "التقارير",
    property: "العقار",
    language: "English",

    // Landing
    hero_title: "إدارة ذكية لعقاراتك",
    hero_sub: "احسب أرباحك ومصاريفك، وتحكم في التقويم اليومي والساعي لعقارك بواجهة عربية أنيقة.",
    hero_cta: "ابدأ مجاناً",
    hero_cta_secondary: "لدي حساب",
    feature_calendar: "تقويم ملون تفاعلي",
    feature_calendar_d: "أبيض للفارغ، أخضر للمؤجَّر، أصفر للمحجوز، مع تحكم كامل.",
    feature_finance: "تتبع مالي دقيق",
    feature_finance_d: "الدخل والمصاريف والربح لكل يوم وأسبوع وشهر وسنة.",
    feature_property: "لأصحاب الاستراحات والنُزُل والكرفانات",
    feature_property_d: "عندك استراحة أو نُزُل أو كرفان وتريد تراقب الحجوزات والأرباح؟ هذا مكانك.",
    trusted_by: "مصمم لأصحاب الاستراحات والشقق والملاعب في عُمان",

    // Auth
    name: "الاسم",
    email: "البريد الإلكتروني",
    phone: "رقم الهاتف",
    password: "كلمة المرور",
    property_name: "اسم العقار",
    property_type: "نوع العقار",
    governorate: "المحافظة",
    wilayat: "الولاية",
    village: "القرية/المنطقة",
    select_governorate: "اختر المحافظة",
    select_wilayat: "اختر الولاية",
    submit: "إرسال",
    creating_account: "جاري إنشاء الحساب...",
    signing_in: "جاري الدخول...",
    dont_have_account: "لا تملك حساباً؟",
    have_account: "تملك حساباً بالفعل؟",
    register_title: "أنشئ حسابك",
    register_sub: "تجربة مجانية لمدة شهر، بدون بطاقة.",
    login_title: "أهلاً بعودتك",
    login_sub: "سجّل دخولك برقم هاتفك وكلمة المرور.",

    // Property types
    type_chalet: "استراحة",
    type_apartment: "شقة",
    type_house: "بيت",
    type_sports_field: "ملعب",
    type_tent: "خيمة",
    type_inn: "نُزُل",
    type_caravan: "كرفان",
    type_other: "أخرى",

    // Dashboard
    welcome: "مرحباً",
    trial_active: "تجربتك المجانية نشطة",
    trial_expired: "انتهت تجربتك المجانية",
    trial_days_left: "يوم متبقٍ",
    subscribe_now: "اشترك الآن",
    monthly_income: "الدخل الشهري",
    monthly_expense: "المصاريف الشهرية",
    monthly_profit: "الربح الشهري",
    rented_days: "أيام التأجير",
    quick_add: "إضافة سريعة",
    upcoming: "القادم",

    // Calendar
    status_empty: "فارغ",
    status_rented: "مؤجَّر",
    status_reserved: "محجوز",
    click_to_change: "اضغط لتغيير الحالة",
    guest_name: "اسم المستأجر",
    guest_phone: "رقم هاتف المستأجر",
    amount: "مبلغ التأجير (ر.ع)",
    deposit: "العربون",
    insurance: "التأمين",
    hours: "عدد الساعات",
    start_time: "وقت البدء",
    end_time: "وقت الانتهاء",
    hourly_booking: "تأجير بالساعة",
    notes: "ملاحظات",
    save: "حفظ",
    delete: "حذف",
    cancel: "إلغاء",
    day_details: "تفاصيل اليوم",

    // Finances
    add_expense: "إضافة مصروف",
    category: "الفئة",
    date: "التاريخ",
    no_expenses: "لا توجد مصاريف بعد",

    // Reports
    period_day: "اليوم",
    period_week: "الأسبوع",
    period_month: "الشهر",
    period_year: "السنة",
    income: "الدخل",
    expense: "المصاريف",
    profit: "الربح",
    comparison: "المقارنة",
    this_week: "هذا الأسبوع",
    last_week: "الأسبوع الماضي",
    this_month: "هذا الشهر",
    last_month: "الشهر الماضي",
    growth: "النمو",

    // Errors / messages
    fields_required: "يرجى تعبئة جميع الحقول",
    saved: "تم الحفظ",
    deleted: "تم الحذف",
    paid_success: "تم تفعيل الاشتراك",

    // Additions
    properties_page: "العقارات",
    admin: "الإدارة",
    add_property: "إضافة عقار",
    all_properties: "جميع العقارات",
    pending_approval: "بانتظار الموافقة",
    approved: "مُفعّل",
    approve: "موافقة",
    reject: "رفض",
    export_csv: "تصدير التقرير (CSV)",
    subscribe_notice: "لإضافة عقار جديد يجب الاشتراك أو انتظار موافقة الإدارة",
    property_added_pending: "تم إرسال العقار وسيتم تفعيله بعد موافقة الإدارة",
    total_users: "إجمالي المستخدمين",
    paid_users: "المشتركون",
    active_trials: "تجارب نشطة",
    expired_trials: "تجارب منتهية",
    total_properties: "إجمالي العقارات",
    pending_properties: "عقارات بانتظار الموافقة",
    total_bookings: "إجمالي الحجوزات",
    platform_income: "دخل المنصة",
    visits: "الزيارات",
    users_list: "قائمة المستخدمين",
    properties_list: "قائمة العقارات",
    bookings_list: "قائمة الحجوزات",
    visits_log: "سجل الزيارات",
    close: "إغلاق",
    grant_subscription: "منح اشتراك",
    grant_subscription_confirm: "منح المستخدم اشتراكاً مدفوعاً؟",
    days_label: "عدد الأيام",
    subscription_granted: "تم منح الاشتراك",
    plan_col: "نوع العضوية",
    plan_standard: "أساسية",
    plan_premium: "مميزة",
    plan_trial: "تجربة مجانية",
    grant_standard: "منح أساسية",
    grant_premium: "منح مميزة",
    ip_address: "عنوان IP",
    user_agent: "المتصفح",
    visit_time: "الوقت",
    property_name: "اسم العقار",
    owner: "المالك",
    booking_date: "تاريخ الحجز",
    booking_status: "الحالة",
    booking_amount: "المبلغ",
    approvals: "الموافقات",
    admin_stats: "الإحصائيات",
    joined_at: "تاريخ الانضمام",
    property_count: "عدد العقارات",
    booking_count: "الحجوزات",
    toggle_paid: "تبديل الاشتراك",
    property_owner: "المالك",
    admin_only_notice: "هذه واجهة الإدارة",

    // Expense categories
    cat_maintenance: "صيانة",
    cat_utilities: "فواتير",
    cat_cleaning: "تنظيف",
    cat_supplies: "مستلزمات",
    cat_salaries: "رواتب",
    cat_marketing: "تسويق",
    cat_other: "أخرى",

    // Payment / subscription
    subscribe_title: "فعّل اشتراكك الشهري",
    subscribe_desc: "اختر الباقة المناسبة. بعد الدفع ستُرسل إلى الإدارة للموافقة على تفعيل حسابك خلال وقت قصير.",
    month: "شهر",
    omr: "ر.ع",
    max_properties: "الحد الأقصى للعقارات",
    plan_standard: "الأساسية",
    plan_premium: "المميزة",
    recommended: "الأكثر طلباً",
    perk_1_property: "عقار واحد",
    perk_3_properties: "حتى 3 عقارات",
    perk_unlimited_props: "إضافة عقارات متعددة",
    perk_reports: "تقارير مالية شاملة (يومي/أسبوعي/شهري/سنوي)",
    perk_calendar: "تقويم تفاعلي كامل مع تفاصيل الحجوزات",
    perk_support: "دعم مستمر ومزايا جديدة",
    pay_and_activate: "ادفع للاشتراك",
    secured_by_ompay: "الدفع مؤمّن عبر OMPay",
    payment_successful: "تم الدفع بنجاح!",
    payment_received: "تم استلام الدفعة",
    awaiting_admin_approval: "طلب التفعيل قيد المراجعة من إدارة الموقع",
    admin_will_review_soon: "سيتم تفعيل حسابك بعد موافقة الإدارة على الطلب. ستظهر لك جميع المزايا فور التفعيل.",
    verifying_payment: "جاري التحقق من الدفع...",
    please_wait: "يرجى الانتظار لحظات",
    payment_failed: "فشلت عملية الدفع",
    please_try_again: "يرجى المحاولة مرة أخرى",
    try_again: "حاول مجدداً",
    payment_cancelled: "تم إلغاء الدفع",
    payment_cancelled_desc: "لم يكتمل الدفع. يمكنك المحاولة مرة أخرى وقتما تشاء.",
    redirecting: "جاري توجيهك للوحة التحكم...",
    back: "رجوع",
    access_expired_title: "انتهت مدة الوصول",
    access_expired_desc: "لإعادة تفعيل حسابك واستخدام جميع مزايا عقاراتي، يرجى الاشتراك.",
    payment_required_add_property: "لإضافة عقار جديد يجب الدفع أولاً",
    property_limit_reached: "لقد وصلت للحد الأقصى من العقارات في باقتك. الرجاء الترقية للباقة المميزة لإضافة المزيد.",

    // Activation requests (admin)
    activation_requests: "طلبات التفعيل",
    activation_approved: "تم قبول طلب التفعيل",
    activation_rejected: "تم رفض طلب التفعيل",
    filter_pending: "قيد الانتظار",
    filter_approved: "تم القبول",
    filter_rejected: "مرفوض",

    // Bookings list
    bookings_history: "قائمة الحجوزات",
    bookings_history_desc: "قاعدة بيانات المستأجرين والحجوزات — جميع الحجوزات مع تفاصيل المستأجر",
    search_guest: "ابحث باسم المستأجر أو رقم الهاتف",

    // Password reset + settings
    forgot_password_link: "نسيت كلمة المرور؟",
    forgot_password_title: "استعادة كلمة المرور",
    forgot_password_gmail_desc: "سنتحقق من هويتك عبر حساب Gmail المسجل ثم نسمح لك بتعيين كلمة مرور جديدة.",
    reset_via_gmail: "استعادة عبر Gmail",
    secured_by_google: "موثّق عبر حساب Google",
    set_new_password: "تعيين كلمة مرور جديدة",
    verified_via_gmail: "تم التحقق من هويتك بنجاح عبر Gmail.",
    confirm_password: "تأكيد كلمة المرور",
    passwords_do_not_match: "كلمتا المرور غير متطابقتين",
    password_min_6: "كلمة المرور يجب ألا تقل عن 6 أحرف",
    back_to_login: "العودة إلى تسجيل الدخول",
    verify_code: "رمز التحقق",
    verify_code_placeholder: "أدخل الرمز المكوّن من 6 أرقام",
    new_password: "كلمة المرور الجديدة",
    reset_password_cta: "تعيين كلمة المرور",
    password_reset_success: "تم تغيير كلمة المرور بنجاح، سجّل الدخول الآن",
    sms_not_available: "خدمة الرسائل غير مفعّلة حالياً، الرجاء التواصل مع الإدارة.",
    fallback_admin_notice: "تم إرسال طلبك إلى الإدارة (خدمة SMS غير مفعّلة).",
    password_reset_requests: "طلبات استعادة كلمة المرور",
    filter_resolved: "تمت المعالجة",
    set_new_password: "تعيين كلمة مرور جديدة",
    share_password_with_user: "شارك كلمة المرور مع العميل عبر الهاتف أو واتساب.",
    regenerate: "توليد جديد",
    apply: "تطبيق",
    password_reset_done: "تم تعديل كلمة المرور",
    admin_settings: "إعدادات الحساب",
    change_password: "تغيير كلمة المرور",
    current_password: "كلمة المرور الحالية",
    new_password: "كلمة المرور الجديدة",
    confirm_password: "تأكيد كلمة المرور",
    password_too_short: "كلمة المرور يجب أن تكون 6 أحرف على الأقل",
    passwords_do_not_match: "كلمتا المرور غير متطابقتين",
    edit: "تعديل",
    pd_overview: "نظرة عامة",
    pd_bookings: "الحجوزات",
    pd_expenses: "المصاريف",
    or: "أو",
    continue_with_google: "المتابعة بحساب Google",
    login_failed: "فشل تسجيل الدخول",

    // Feedback (Suggestions & Complaints)
    feedback: "الاقتراحات والشكاوى",
    feedback_desc: "شاركنا اقتراحك أو مشكلتك وسنراجعها في أقرب وقت.",
    feedback_send: "إرسال",
    feedback_kind: "النوع",
    feedback_suggestion: "اقتراح",
    feedback_complaint: "شكوى",
    feedback_subject: "العنوان",
    feedback_message: "الرسالة",
    feedback_sent: "تم إرسال رسالتك بنجاح",
    feedback_my_history: "رسائلي السابقة",
    feedback_status_open: "قيد المراجعة",
    feedback_status_resolved: "تم الرد",
    admin_feedback: "الاقتراحات والشكاوى",
    mark_resolved: "تحديد كمعالج",
    no_feedback_yet: "لا توجد رسائل بعد",
    // Admin management
    manage_admins: "إدارة الحسابات الإدارية",
    add_admin: "إضافة مدير جديد",
    admin_name: "الاسم",
    admin_phone: "الهاتف / اسم المستخدم",
    admin_password: "كلمة المرور",
    admin_email: "البريد الإلكتروني (اختياري)",
    admin_created: "تمت إضافة المدير",
    admin_deleted: "تم حذف المدير",
    delete_admin_confirm: "هل أنت متأكد من حذف هذا المدير؟",
    // Payments analytics
    payments_analytics: "إحصائيات المدفوعات",
    total_revenue: "إجمالي الإيرادات",
    revenue_today: "إيرادات اليوم",
    revenue_last_7: "آخر 7 أيام",
    revenue_this_month: "هذا الشهر",
    active_subscriptions: "الاشتراكات النشطة",
    expired_subscriptions: "الاشتراكات المنتهية",
    total_transactions: "عدد العمليات",
    successful_txs: "ناجحة",
    failed_txs: "فاشلة",
    pending_txs: "قيد الانتظار",
    monthly_revenue: "الإيرادات الشهرية (آخر 12 شهر)",
    recent_transactions: "أحدث العمليات",
    tx_order_id: "معرف الطلب",
    tx_user: "المستخدم",
    tx_amount: "المبلغ",
    tx_package: "الباقة",
    tx_status: "الحالة",
    tx_date: "التاريخ",
    tx_type: "النوع",
    tx_manual: "منح يدوي",
    tx_ompay: "OMPay",
    tx_status_paid: "مدفوعة",
    tx_status_pending: "معلقة",
    tx_status_failed: "فاشلة",
    // Upgrade for extra property
    upgrade_for_more_properties: "ترقية للحصول على عقارات إضافية",
    upgrade_desc: "لديك عقار واحد بالفعل. رقّي إلى الباقة المميزة لإضافة المزيد من العقارات.",
    no_upgrade_available: "لا توجد باقة أعلى متاحة حالياً. تواصل مع الإدارة لإضافة عقارات إضافية.",

    // Hourly bookings (sports fields)
    field_bookings_day: "حجوزات هذا اليوم",
    add_time_slot: "إضافة وقت جديد",
    time_range: "الفترة",
    no_bookings_this_day: "لا يوجد حجز في هذا اليوم",
    delete_this_slot: "حذف هذا الحجز",
    slot_saved: "تم حفظ الحجز",
    slot_deleted: "تم حذف الحجز",
    from_time: "من",
    to_time: "إلى",
    total_slots: "عدد الحجوزات",
    view_grid: "جدول ساعي",
    view_list: "قائمة",
    hourly_grid: "الجدول الساعي",
    amount_required: "المبلغ مطلوب ويجب أن يكون أكبر من صفر",
    click_hour_to_add: "اضغط على الساعة الفارغة للإضافة",

    // Admin filters
    filter_all: "الجميع",
    filter_paid: "المشتركون",
    filter_trial_active: "تجارب نشطة",
    filter_trial_expired: "تجارب منتهية",
    search: "بحث",
    sort_by: "ترتيب حسب",
    sort_created: "الأحدث",
    sort_name: "الاسم",
    sort_property_count: "عدد العقارات",
    sort_booking_count: "الحجوزات",

    // Backend error mappings (English → Arabic)
    err_prefix: "خطأ: ",
    __errors__: {
      "Email or phone already registered": "البريد الإلكتروني أو رقم الهاتف مسجّل مسبقاً",
      "Invalid phone or password": "رقم الهاتف أو كلمة المرور غير صحيحة",
      "Trial expired. Payment required.": "انتهت التجربة المجانية. يرجى الاشتراك للمتابعة.",
      "Additional properties require paid subscription": "إضافة عقار جديد تتطلب اشتراكاً مدفوعاً",
      "Payment required to add additional properties": "لإضافة عقار جديد يجب الدفع أولاً",
      "Property pending admin approval": "العقار قيد الانتظار للموافقة من الإدارة",
      "Not authenticated": "يرجى تسجيل الدخول أولاً",
      "Token expired": "انتهت الجلسة، يرجى تسجيل الدخول مجدداً",
      "Invalid token": "جلسة غير صالحة، يرجى تسجيل الدخول مجدداً",
      "User not found": "المستخدم غير موجود",
      "Property not found": "العقار غير موجود",
      "Booking not found": "الحجز غير موجود",
      "Expense not found": "المصروف غير موجود",
      "Admin access required": "هذه الصفحة مخصصة للإدارة فقط",
      "Field required": "الحقل مطلوب",
      "value is not a valid email address": "صيغة البريد الإلكتروني غير صحيحة",
      "String should have at least 6 characters": "يجب أن تكون كلمة المرور 6 أحرف على الأقل",
      "String should have at least 2 characters": "الحقل يجب أن يحتوي على حرفين على الأقل",
    },
  },
  en: {
    dir: "ltr",
    brand: "Aqarati",
    login: "Sign in",
    register: "Sign up",
    logout: "Sign out",
    dashboard: "Dashboard",
    calendar: "Calendar",
    finances: "Finances",
    reports: "Reports",
    property: "Property",
    language: "العربية",

    hero_title: "Smart management for your rentals",
    hero_sub: "Track income, expenses, and daily/hourly bookings for your chalet, apartment, or field in one elegant place.",
    hero_cta: "Start 1 month free",
    hero_cta_secondary: "I have an account",
    feature_calendar: "Interactive colored calendar",
    feature_calendar_d: "White=empty, Green=rented, Yellow=reserved — fully editable.",
    feature_finance: "Precise finance tracking",
    feature_finance_d: "Income, expenses & profit per day, week, month, year.",
    feature_property: "One property, free",
    feature_property_d: "Add one property free. Subscribe to add more.",
    trusted_by: "Built for chalet, apartment & sports-field owners across Oman",

    name: "Name",
    email: "Email",
    phone: "Phone",
    password: "Password",
    property_name: "Property name",
    property_type: "Property type",
    governorate: "Governorate",
    wilayat: "Wilayat",
    village: "Village / Area",
    select_governorate: "Select governorate",
    select_wilayat: "Select wilayat",
    submit: "Submit",
    creating_account: "Creating account...",
    signing_in: "Signing in...",
    dont_have_account: "Don't have an account?",
    have_account: "Already have an account?",
    register_title: "Create your account",
    register_sub: "1 month free trial, no card required.",
    login_title: "Welcome back",
    login_sub: "Sign in with your phone and password.",

    type_chalet: "Chalet",
    type_apartment: "Apartment",
    type_house: "House",
    type_sports_field: "Sports Field",
    type_tent: "Tent",
    type_inn: "Inn",
    type_caravan: "Caravan",
    type_other: "Other",

    welcome: "Welcome",
    trial_active: "Your free trial is active",
    trial_expired: "Your free trial has ended",
    trial_days_left: "days left",
    subscribe_now: "Subscribe now",
    monthly_income: "Monthly income",
    monthly_expense: "Monthly expenses",
    monthly_profit: "Monthly profit",
    rented_days: "Rented days",
    quick_add: "Quick add",
    upcoming: "Upcoming",

    status_empty: "Empty",
    status_rented: "Rented",
    status_reserved: "Reserved",
    click_to_change: "Click to change status",
    guest_name: "Guest name",
    guest_phone: "Guest phone",
    amount: "Rental amount (OMR)",
    deposit: "Deposit / Down payment",
    insurance: "Security deposit",
    hours: "Hours",
    start_time: "Start time",
    end_time: "End time",
    hourly_booking: "Hourly booking",
    notes: "Notes",
    save: "Save",
    delete: "Delete",
    cancel: "Cancel",
    day_details: "Day details",

    add_expense: "Add expense",
    category: "Category",
    date: "Date",
    no_expenses: "No expenses yet",

    period_day: "Day",
    period_week: "Week",
    period_month: "Month",
    period_year: "Year",
    income: "Income",
    expense: "Expense",
    profit: "Profit",
    comparison: "Comparison",
    this_week: "This week",
    last_week: "Last week",
    this_month: "This month",
    last_month: "Last month",
    growth: "Growth",

    fields_required: "Please fill all fields",
    saved: "Saved",
    deleted: "Deleted",
    paid_success: "Subscription activated",

    properties_page: "Properties",
    admin: "Admin",
    add_property: "Add property",
    all_properties: "All properties",
    pending_approval: "Pending approval",
    approved: "Approved",
    approve: "Approve",
    reject: "Reject",
    export_csv: "Export CSV",
    subscribe_notice: "To add a new property, please subscribe or wait for admin approval",
    property_added_pending: "Property submitted. It will be activated after admin approval.",
    total_users: "Total users",
    paid_users: "Paid subscribers",
    active_trials: "Active trials",
    expired_trials: "Expired trials",
    total_properties: "Total properties",
    pending_properties: "Pending properties",
    total_bookings: "Total bookings",
    platform_income: "Platform income",
    visits: "Visits",
    users_list: "Users",
    properties_list: "Properties",
    bookings_list: "Bookings",
    visits_log: "Visits log",
    close: "Close",
    grant_subscription: "Grant subscription",
    grant_subscription_confirm: "Grant paid subscription to this user?",
    days_label: "Days",
    subscription_granted: "Subscription granted",
    plan_col: "Plan",
    plan_standard: "Standard",
    plan_premium: "Premium",
    plan_trial: "Free trial",
    grant_standard: "Grant Standard",
    grant_premium: "Grant Premium",
    ip_address: "IP",
    user_agent: "Browser",
    visit_time: "Time",
    property_name: "Property",
    owner: "Owner",
    booking_date: "Date",
    booking_status: "Status",
    booking_amount: "Amount",
    approvals: "Approvals",
    admin_stats: "Statistics",
    joined_at: "Joined",
    property_count: "Properties",
    booking_count: "Bookings",
    toggle_paid: "Toggle paid",
    property_owner: "Owner",
    admin_only_notice: "Admin panel",

    cat_maintenance: "Maintenance",
    cat_utilities: "Utilities",
    cat_cleaning: "Cleaning",
    cat_supplies: "Supplies",
    cat_salaries: "Salaries",
    cat_marketing: "Marketing",
    cat_other: "Other",

    subscribe_title: "Activate your monthly subscription",
    subscribe_desc: "Pick the plan that suits you. Once payment is made, your activation request will be reviewed by the site admin.",
    month: "month",
    omr: "OMR",
    max_properties: "Max properties",
    plan_standard: "Standard",
    plan_premium: "Premium",
    recommended: "Most popular",
    perk_1_property: "1 property",
    perk_3_properties: "Up to 3 properties",
    perk_unlimited_props: "Add multiple properties",
    perk_reports: "Full financial reports (day/week/month/year)",
    perk_calendar: "Interactive calendar with booking details",
    perk_support: "Continuous support & new features",
    pay_and_activate: "Pay to subscribe",
    secured_by_ompay: "Secured by OMPay",
    payment_successful: "Payment successful!",
    payment_received: "Payment received",
    awaiting_admin_approval: "Your activation request is pending admin review",
    admin_will_review_soon: "Your account will be activated once admin approves your request. All features will be visible immediately after activation.",
    verifying_payment: "Verifying payment…",
    please_wait: "Please wait a moment",
    payment_failed: "Payment failed",
    please_try_again: "Please try again",
    try_again: "Try again",
    payment_cancelled: "Payment cancelled",
    payment_cancelled_desc: "Payment was not completed. You can retry anytime.",
    redirecting: "Redirecting to the dashboard…",
    back: "Back",
    access_expired_title: "Access expired",
    access_expired_desc: "To reactivate your account and access all Aqarati features, please subscribe.",
    payment_required_add_property: "Payment is required to add a new property",
    property_limit_reached: "You reached the property limit of your plan. Upgrade to Premium to add more.",

    activation_requests: "Activation requests",
    activation_approved: "Activation request approved",
    activation_rejected: "Activation request rejected",
    filter_pending: "Pending",
    filter_approved: "Approved",
    filter_rejected: "Rejected",

    bookings_history: "Bookings",
    bookings_history_desc: "Guest & booking database — all bookings with renter details",
    search_guest: "Search by guest name or phone",

    forgot_password_link: "Forgot password?",
    forgot_password_title: "Reset password",
    forgot_password_gmail_desc: "We'll verify your identity via your registered Gmail, then let you set a new password.",
    reset_via_gmail: "Reset via Gmail",
    secured_by_google: "Verified via Google",
    set_new_password: "Set new password",
    verified_via_gmail: "Your identity has been verified via Gmail.",
    confirm_password: "Confirm password",
    passwords_do_not_match: "Passwords do not match",
    password_min_6: "Password must be at least 6 characters",
    back_to_login: "Back to login",
    verify_code: "Verification code",
    verify_code_placeholder: "Enter the 6-digit code",
    new_password: "New password",
    reset_password_cta: "Set new password",
    password_reset_success: "Password changed successfully. Please sign in.",
    sms_not_available: "SMS service is not available. Please contact the admin.",
    fallback_admin_notice: "Your request was sent to the admin (SMS service is not configured).",
    password_reset_requests: "Password reset requests",
    filter_resolved: "Resolved",
    set_new_password: "Set a new password",
    share_password_with_user: "Share this password with the user via phone or WhatsApp.",
    regenerate: "Regenerate",
    apply: "Apply",
    password_reset_done: "Password updated",
    admin_settings: "Account settings",
    change_password: "Change password",
    current_password: "Current password",
    new_password: "New password",
    confirm_password: "Confirm password",
    password_too_short: "Password must be at least 6 characters",
    passwords_do_not_match: "Passwords do not match",
    edit: "Edit",
    pd_overview: "Overview",
    pd_bookings: "Bookings",
    pd_expenses: "Expenses",
    or: "or",
    continue_with_google: "Continue with Google",
    login_failed: "Login failed",

    // Feedback
    feedback: "Suggestions & Complaints",
    feedback_desc: "Share your suggestion or issue and we'll review it soon.",
    feedback_send: "Send",
    feedback_kind: "Type",
    feedback_suggestion: "Suggestion",
    feedback_complaint: "Complaint",
    feedback_subject: "Subject",
    feedback_message: "Message",
    feedback_sent: "Message sent successfully",
    feedback_my_history: "My previous messages",
    feedback_status_open: "Under review",
    feedback_status_resolved: "Resolved",
    admin_feedback: "Suggestions & Complaints",
    mark_resolved: "Mark resolved",
    no_feedback_yet: "No messages yet",
    // Admin management
    manage_admins: "Manage admin accounts",
    add_admin: "Add new admin",
    admin_name: "Name",
    admin_phone: "Phone / Username",
    admin_password: "Password",
    admin_email: "Email (optional)",
    admin_created: "Admin created",
    admin_deleted: "Admin deleted",
    delete_admin_confirm: "Are you sure you want to delete this admin?",
    // Payments analytics
    payments_analytics: "Payments Analytics",
    total_revenue: "Total revenue",
    revenue_today: "Today",
    revenue_last_7: "Last 7 days",
    revenue_this_month: "This month",
    active_subscriptions: "Active subscriptions",
    expired_subscriptions: "Expired subscriptions",
    total_transactions: "Transactions",
    successful_txs: "Successful",
    failed_txs: "Failed",
    pending_txs: "Pending",
    monthly_revenue: "Monthly revenue (last 12 months)",
    recent_transactions: "Recent transactions",
    tx_order_id: "Order ID",
    tx_user: "User",
    tx_amount: "Amount",
    tx_package: "Package",
    tx_status: "Status",
    tx_date: "Date",
    tx_type: "Type",
    tx_manual: "Manual grant",
    tx_ompay: "OMPay",
    tx_status_paid: "Paid",
    tx_status_pending: "Pending",
    tx_status_failed: "Failed",
    // Upgrade for extra property
    upgrade_for_more_properties: "Upgrade for extra properties",
    upgrade_desc: "You already have a property. Upgrade to Premium to add more.",
    no_upgrade_available: "No higher plan available right now. Contact admin for extra properties.",

    // Hourly bookings
    field_bookings_day: "Bookings on this day",
    add_time_slot: "Add new time slot",
    time_range: "Time",
    no_bookings_this_day: "No bookings this day",
    delete_this_slot: "Delete this slot",
    slot_saved: "Slot saved",
    slot_deleted: "Slot deleted",
    from_time: "From",
    to_time: "To",
    total_slots: "Slots count",
    view_grid: "Hour grid",
    view_list: "List",
    hourly_grid: "Hour grid",
    amount_required: "Amount is required and must be greater than 0",
    click_hour_to_add: "Click an empty hour to add",

    filter_all: "All",
    filter_paid: "Paid",
    filter_trial_active: "Active trials",
    filter_trial_expired: "Expired trials",
    search: "Search",
    sort_by: "Sort by",
    sort_created: "Newest",
    sort_name: "Name",
    sort_property_count: "Properties",
    sort_booking_count: "Bookings",

    err_prefix: "Error: ",
    __errors__: {},
  },
};

export const propertyTypes = ["chalet", "apartment", "house", "sports_field", "tent", "inn", "caravan", "other"];
